export default {
  car: {
    id: 'car',
    width: '79.97',
    height: '41.6',
    transform: 'rotate(186) scale(0.7,0.7) translate(-40,-20)',
  },
  train: {
    id: 'carriage_1',
    width: '80',
    height: '23.2',
    transform: 'rotate(180) scale(0.6,0.6) translate(-39.5045,-11.6)',
  },
  plane: {
    id: 'plane',
    width: '80',
    height: '78.9',
    transform: 'rotate(225) scale(0.6,0.6) translate(-37.2823,-39.3677)',
  },
};
